<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            消费结算
        </div>
        <div style="padding: 20px;">

            <div class="BerthPage">

                <el-row> 
                    <!-- <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button> -->
                    <div style="float:right">
                        <el-cascader
                            v-model="roomCodeList"
                            placeholder="请选择房间"
                            :options="options"
                            filterable
                            clearable
                            @change="handleChange" style="margin:0 10px;float:left">
                        </el-cascader>
                        <el-input  placeholder="请输入床号" v-model="number" clearable  style="margin:0 10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">

                        <el-table-column prop="roomNumber" label="房间号"></el-table-column>

                        <el-table-column prop="number" label="床位"></el-table-column>

                        <el-table-column prop="building.name" label="楼宇名称"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>


    </div>
</template>

<script>

    // import {timeStr} from "@/common/times";
    // import {hex_md5} from "@/common/Base64MD5";

    // import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                roomCodeList:[],
                currentPage:1,
                roomCode:'00000000-0000-0000-0000-000000000000',
                number:'',
                th:0,
                options:[]
            }
        },
       
        created(){
            this.getList();
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init:function(){
                // this.$axios({
                //     method: 'post',
                //     url: this.$institutionUrl+"Room/ListRoom",
                //     data: {
                //         timeStr: timeStr,
                //         sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                //         staffCode: getStaffCode(),
                //     }
                // }).then(
                //     (response) => {
                //         if (response.data.error == 0) {
                //             var datas= response.data.data;
                //             var JSONData=JSON.stringify(datas);
                //             JSONData=JSONData.replace(/listRoomDTO/g,'children');
                //             JSONData=JSONData.replace(/name/g,'label');
                //             JSONData=JSONData.replace(/roomCode/g,'value');
                //             JSONData=JSONData.replace(/number/g,'label');
                //             this.options = JSON.parse(JSONData);
                //         }else if(response.data.error == 1){
                //             this.$message({type: 'info', message: response.data.message});
                //         }
                //     }
                // )
            },
            handleClear(){
                this.roomCode='00000000-0000-0000-0000-000000000000';
                console.log(this.roomCode)
            },
            handleChange(value) {
                if(value.length==0){
                    this.roomCode='00000000-0000-0000-0000-000000000000';
                }else{
                    this.roomCode=value[1];
                }
                console.log(this.roomCode);
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                // var numbers=0;
                // if(this.number){
                //     numbers=this.number;
                // }
                // console.log(this.roomCode)
                // this.$axios({
                //     method: 'post',
                //     url: this.$institutionUrl+"Berth/Page",
                //     data: {
                //         timeStr:timeStr,
                //         sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                //         staffCode: getStaffCode(),
                //         number:numbers,
                //         roomCode:this.roomCode,
                //         pageIndex:this.currentPage,
                //         pageSize:this.pageSize,
                //     }
                // }).then( (response)=> {
                //     console.log(response);
                //     if(response.data.error == 0){
                //         this.tableData = response.data.data.list;
                //         this.totalItems = response.data.data.total;
                //     }else if(response.data.error == 1){
                //         this.$message({type: 'info', message: response.data.message});
                //     }
                // }).catch(function (error) {
                //     console.log(error);
                // });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
             roomTypeTitle(row){
                if(row.roomType == 1){
                    return "单人间";
                }
                if(row.roomType == 2){
                    return "双人间";
                }
            },



        }
    }
</script>

<style lang="scss" scoped>
    .BerthPage{
        .el-button{
            transform: translate(-1px,0);
        }
    }
</style>
